import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const MarqueeApi = createApi({
  reducerPath: "MarqueeApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["MARQUEEAPI"],
  endpoints: (build) => ({
    getMarquee: build.query({
      query: () => ({
        url: `/marquee`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["MARQUEEAPI"],
    }),

    getActiveMarquee: build.query({
      query: () => ({
        url: `/marquee/active`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["MARQUEEAPI"],
    }),

    updateMarquee: build.mutation({
      query: ({ data }) => ({
        url: `/marquee`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["MARQUEEAPI"],
    }),

    toggleMarqueeStatus: build.mutation({
      query: () => ({
        url: `/marquee/toggle`,
        method: "PATCH",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["MARQUEEAPI"],
    }),
  }),
});

export const {
  useGetMarqueeQuery,
  useGetActiveMarqueeQuery,
  useUpdateMarqueeMutation,
  useToggleMarqueeStatusMutation,
} = MarqueeApi;
